const emitEvent = (eventName: string): void => {
  const event = new Event(eventName);
  document.dispatchEvent(event);
};

export default emitEvent;
